export default __webpack_public_path__ + "static/media/cotemar.6f57bf4f.png";